require('./polyfills.js')
import Vue from 'vue'
import axios from 'axios'
import VueRouter from 'vue-router'
import VueAxios from 'vue-axios'
import routes from './routes.js'
import store from './store.js'
import Promise from 'promise-polyfill'
import { after, before } from './interceptors'

// import * as VueGoogleMaps from 'vue2-google-maps'
const VueGoogleMaps = require('vue2-google-maps')

// To add to window
if (!window.Promise) {
  window.Promise = Promise
}

Vue.use(VueRouter)
Vue.use(VueAxios, axios)
Vue.use(VueGoogleMaps, {
	load: {
		key: "AIzaSyAhVKSM7cCwOBMwHGc3fSuIepX5xbk1Shs"
	}
})

const router = new VueRouter({
	routes: routes,
	mode: 'history'
})

window.Vue = Vue
window.axios = axios
window.VueStore = store
window.VueRouter = router

window.axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest',
  'Access-Control-Allow-Origin': '*'
}

// Vue.axios.interceptors.response.use(null, after)
Vue.axios.interceptors.request.use(before, null)

var app = new Vue({
  el: '#app',
  router: router,
  store: store
})

/* router.beforeEach((to, from, next) => {
	let auth = store.getters.token

	if (typeof auth === 'undefined' || auth === null) {
		auth = ''
	}

	if (to.meta.mode === 'login' && auth !== '') {
		next({ path: from.path })
	} else if (to.meta.mode === 'login' && auth === '') {
		next()
	} else if (to.meta.mode === 'logout') {
		// console.log('5');
		axios.delete('/api/session/')
		.then(res => {
			store.commit('token', '')
			VueRouter.replace('/')
		})
		.catch(err => {
			store.commit('token', '')
			VueRouter.replace('/')
		})
	} else if (to.meta.mode === 'page' && auth === '') {
		VueRouter.replace('/')
	} else if (to.meta.mode === 'page' && auth !== '') {
		app.loggedIn = true
		next()
	}
}) */



// WEBPACK FOOTER //
// ./src/main.js